import { z } from "zod";
export const ReminderKind = z.enum(["article", "recipe", "reset"]);
export const CreateReminderRequest = z.object({
    kind: ReminderKind,
    title: z.string().min(1).max(300),
    body: z.string().min(1).max(1000).optional(),
    deepLink: z.string().min(1).max(500).optional(),
    refType: z.string().min(1).max(80).optional(),
    refId: z.string().min(1).max(300).optional(),
    dedupeKey: z.string().min(1).max(500).optional(),
    deliverAt: z.string().datetime(),
});
export const CreateReminderResponse = z.object({
    ok: z.literal(true),
    deliverAt: z.string().datetime(),
});
//# sourceMappingURL=reminders.js.map